<template>
  <a>{{ $t("consultarcalendario")  }}</a>
</template>

<script>
export default {
  name: 'calendarButton',
}
</script>

<style scoped>
  a{
    display: flex;
    background-color: #1976d2;
    color: white;
    padding: 14px;
    width: 100%;
    justify-content: center;
    border-radius: 8px;
    font-size: 16px;
    font-family: "Montserrat Light";
  }
</style>